<template>
    <div>
        <el-form ref="searchForm" :inline="true" :model="searchForm" @submit.native.prevent>
            <el-form-item label="代理商名称：">
                <el-input v-model.trim="searchForm.name" @keyup.enter.native="getAgentListHandle" clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="getAgentListHandle">搜索</el-button>
                <el-button type="success" @click="showAddNewAgentHandle">新增</el-button>
                <el-button type="primary" @click="showActivateDetailHandle">激活详情</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="tbpg.tableData" border >
            <el-table-column type="index" width="50"></el-table-column>
            <el-table-column prop="name" label="代理商名称 "></el-table-column>
            <el-table-column prop="sysUserAccountName" label="账号"></el-table-column>
            <el-table-column prop="sysUserMobile" label="手机号"></el-table-column>
            <el-table-column prop="createTime" label="创建时间"></el-table-column>
            <el-table-column prop="createOptName" label="添加人"></el-table-column>
            <el-table-column prop="profit" label="销售折扣"></el-table-column>
            <el-table-column prop="commissionBalanceRmb" label="代理商返现（元）"></el-table-column>
            <el-table-column prop="prechargeBalanceRmb" label="预充值余额（元）"></el-table-column>
            <el-table-column prop="simNum" label="SIM卡总数"></el-table-column>
            <el-table-column prop="simActivation" label="激活数"></el-table-column>
            <el-table-column prop="simActivationRatio" label="激活比例（%）"></el-table-column>
            <el-table-column prop="authName" label="实名认证状态"></el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">                    
                    <el-button type="text" size="small" @click="showEditAgentInfo(scope.row)">编辑</el-button>
                    <el-button type="text" size="small" v-if="hasAuthority('reset_password')"  @click="resetPwdHandle(scope.row.sysUserId)">重置密码</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination> 
        <el-dialog :append-to-body="true"  :title="title" :visible.sync="addNewAgentVisibale" width="600px" @close="cancel" :close-on-click-modal="false">
            <el-form ref="newAgentForm" :model="newAgentForm" :rules="newAgentFormRules" label-width="120px">
                <el-form-item label="代理商名称：" prop="name">
                    <el-input v-model.trim="newAgentForm.name" :disabled="accountDisabled" clearable></el-input>
                </el-form-item>
                <el-form-item label="账号：" prop="sysUserAccountName">
                    <el-input v-model.trim="newAgentForm.sysUserAccountName" :disabled="accountDisabled" clearable></el-input>
                </el-form-item>
                <el-form-item v-if="addFlag" label="密码：" prop="sysUserAccountPwd">
                    <el-input v-model.trim="newAgentForm.sysUserAccountPwd" show-password clearable></el-input>
                </el-form-item>
                <el-form-item label="手机号：" prop="sysUserMobile">
                    <el-input v-model.trim="newAgentForm.sysUserMobile" clearable></el-input>
                </el-form-item>
                <el-form-item label="密钥：" >
                    <el-input v-model.trim="newAgentForm.keyss" clearable></el-input>
                </el-form-item>
                <el-form-item label="销售折扣：" prop="profit">
                    <el-row>
                        <el-col :span="22">
                            <el-input type="number" v-model.number.trim="newAgentForm.profit" placeholder="请输入销售折扣0~100" clearable></el-input>
                        </el-col>
                        <el-col :span="2" class="center">%</el-col>    
                    </el-row>
                    <el-row>
                        <span>提醒：销售折扣 = （100 - 返点比例）%</span>
                    </el-row>                    
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="addOrEditNewAgentHandle">确 定</el-button>
            </div>   
        </el-dialog>
        <!-- 激活详情 -->
        <el-dialog :append-to-body="true" title="激活详情" :visible.sync="activateDetailVisible" width="1000px" @close="activateDetailCancel" :close-on-click-modal="false">
            <el-form :model="activateDetailForm" label-width="120px" :inline="true" ref="activateDetailForm">
                <!-- <el-form-item label="代理商名称：" prop="agentName">
                    <el-input v-model.trim="activateDetailForm.agentName" clearable></el-input>
                </el-form-item> -->
                <el-form-item label="代理商名称：" prop="agentName">
                    <el-select v-model="activateDetailForm.agentName" placeholder="请选择" clearable filterable>
                        <el-option v-for="item in agentList" :label='item.name + "(" + item.sysUserAccountName + ")"'  :value='item.name' :key="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="运营商名称：" v-if="agentId == 'null'" prop="supplierCode">
                    <el-select v-model="activateDetailForm.supplierCode" placeholder="请选择" clearable filterable>
                        <el-option v-for="item in supplierList" :label='item.name + "(" + item.alias + ")"'  :value='item.name + "=" + item.id' :key="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="通道名称：" v-else prop="supplierName">
                    <el-input v-model.trim="activateDetailForm.supplierName" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="getActivateDetailList">搜索</el-button>
                </el-form-item>
            </el-form>
            <el-table :data="activateDetailData" border>
                <el-table-column type="index" width="50" label="序号"></el-table-column>
                <el-table-column prop="agentName" label="代理商名称" width="150"></el-table-column>
                <el-table-column prop="supplierCode" label="运营商名称" width="200" v-if="agentId == 'null'"></el-table-column>
                <el-table-column prop="supplierName" label="通道名称" width="200" v-else></el-table-column>
                <el-table-column prop="simNum" label="SIM卡总数"></el-table-column>
                <el-table-column prop="simActivation" label="激活数"></el-table-column>
                <el-table-column prop="simActivationRatio" label="激活比例（%）"></el-table-column>
            </el-table>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="emptyActivateDetailData">清空</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {addNewAgent, getAgentList, updateAgentInfo, getAgentListOption} from '@/api/customers.js'
import {resetUserPwd} from '@/api/user.js'
import {mapGetters } from "vuex";
import common from '@/utils/common.js'
export default {
    data(){
        return {
            searchForm: {
                name: ''
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0                 
            },            
            addNewAgentVisibale: false,
            title: '新增代理商',
            accountDisabled: false,
            newAgentForm: {
                name: '',
                sysUserAccountName: '',
                sysUserAccountPwd: '',
                sysUserMobile: '',
                profit: '',
                bankName: '',
                idCard: '',
                subbranch: '',
                bankCardNo: '',
                accountName: '',
                bindMobile: '',
				alipayAccount: '',
                keyss:''
            },
            addFlag: true,
            currentId: '',
            newAgentFormRules: {
                name: [{required: true, message: '请输入代理商名称', trigger: 'blur'}],
                sysUserAccountName: [{required: true, validator: this.checkAccount, trigger: 'blur'}],
                sysUserAccountPwd: [{required: true, validator: this.checkPassword,trigger: 'blur'}],
                sysUserMobile: [{required: true, validator: this.checkPhone, trigger: 'blur'}],
                profit: [{required: true, validator: this.checkInt, trigger: 'blur'},
                        { type: 'date', min: 0, max: 99, message: '可取范围 0 ~ 99', trigger: 'blur' }]
            },
            //激活详情
            activateDetailVisible: false,
            activateDetailForm: {
                agentName: '',
                supplierCode: '',
                supplierName: ''
            },
            activateDetailData: [],
            supplierList: [],
            agentList: [],
            agentId: localStorage.getItem('agentId')
        }
    },
    computed:{
        ...mapGetters("menu", {
            hasAuthority: "hasAuthority" 
        })
    },
    methods: {
        resetPwdHandle(id){
            resetUserPwd({'id': id}).then(res => {
                this.$message.success(res.data.message)
            })
        },
        cancel(){
            this.addNewAgentVisibale = false;
            this.$refs.newAgentForm.resetFields(); 
            for (let key in this.newAgentForm) {
                this.newAgentForm[key] = "";
            }
        },
        getAgentListHandle($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);  
            getAgentList(data).then(res => {
                for(let i=0;i<res.data.data.resultList.length;i++){
                    if(!res.data.data.resultList[i].simActivationRatio){
                        res.data.data.resultList[i].simActivationRatio = 0
                    }
                    if(!res.data.data.resultList[i].simNum){
                        res.data.data.resultList[i].simNum = 0;
                    }
                    if(!res.data.data.resultList[i].simActivation){
                        res.data.data.resultList[i].simActivation = 0;
                    }
                }
                common.listCallback(this, res, 'tbpg');
            })
        },
        showAddNewAgentHandle(){
            this.title = '新增代理商';
            this.addNewAgentVisibale = true;
            this.accountDisabled = false;
            this.addFlag = true;
        },
        showEditAgentInfo(row){
            this.title = '修改代理商信息';
            this.addNewAgentVisibale = true;
            this.accountDisabled = true;
            this.addFlag = false;
            this.currentId = row.id;
            for(var key in this.newAgentForm){                
                if(typeof(row[key]) == 'string'){
                    this.newAgentForm[key] = (row[key]).replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
                }else{
                    this.newAgentForm[key] = row[key];
                }                
            }
        },
        addOrEditNewAgentHandle(){
            this.$refs.newAgentForm.validate(valid => {
                if(valid){
                    var data = this.newAgentForm;     
                    if(this.addFlag){
                        addNewAgent(data).then(res => callback(res))
                    }else{
                        data.id = this.currentId;
                        updateAgentInfo(data).then(res => callback(res))                        
                    }
                }
                var _this = this;
                function callback(res){
                    if(res.data.code == 200){
                        _this.$message.success(res.data.message)
                        _this.getAgentListHandle();
                        _this.addNewAgentVisibale = false;
                        
                    }else{
                        _this.$message.error(res.data.message)
                    }                     
                }
            })
        },
        //激活详情
        showActivateDetailHandle(){
            this.activateDetailVisible = true;
            if(this.agentId == 'null'){
                this.getSupplierList();
            }
            this.getAgentListOptionHandle();
        },
        activateDetailCancel(){
            this.activateDetailVisible = false;
            this.$refs.activateDetailForm.resetFields();
        },
        getSupplierList(){
            common.sysRequest('sim/supplier/list', {}, 'post').then(res => {
                if(res.data.code == 200){
                    this.supplierList = res.data.data;
                }
            })
        },
        getActivateDetailList(){
            if(this.activateDetailData.length > 9){
                this.$message.error('最多显示10条');
                return;
            }
            if(this.agentId == 'null'){
                let data = {
                    agentName: this.activateDetailForm.agentName,
                    supplierCode: this.activateDetailForm.supplierCode.split('=')[1]
                }
                common.sysRequest('agent/activation/admin/list', data, 'post').then(res => {
                    if(res.data.code == 200){
                        let obj = {};
                        obj.simNum = res.data.data.simNum ? res.data.data.simNum : 0;
                        obj.simActivation = res.data.data.simActivation ? res.data.data.simActivation : 0;
                        obj.simActivationRatio = res.data.data.simActivationRatio ? res.data.data.simActivationRatio : 0;
                        obj.agentName = this.activateDetailForm.agentName;
                        obj.supplierCode = this.activateDetailForm.supplierCode.split('=')[0];
                        this.activateDetailData.push(obj)
                    }else {
                        this.$message.error(res.data.message)
                    }
                    this.$refs.activateDetailForm.resetFields();
                })
            }else {
                let data = {
                    agentName: this.activateDetailForm.agentName,
                    supplierName: this.activateDetailForm.supplierName
                }
                common.sysRequest('agent/activation/agent/list', data, 'post').then(res => {
                    if(res.data.code == 200){
                        let obj = {};
                        obj.simNum = res.data.data.simNum ? res.data.data.simNum : 0;
                        obj.simActivation = res.data.data.simActivation ? res.data.data.simActivation : 0;
                        obj.simActivationRatio = res.data.data.simActivationRatio ? res.data.data.simActivationRatio : 0;
                        obj.agentName = this.activateDetailForm.agentName;
                        obj.supplierName = this.activateDetailForm.supplierName;
                        this.activateDetailData.push(obj)
                    }else {
                        this.$message.error(res.data.message)
                    }
                    this.$refs.activateDetailForm.resetFields();
                })
            }
        },
        emptyActivateDetailData(){
            this.activateDetailData = [];
        },
        getAgentListOptionHandle(){
            getAgentListOption({}).then(res => {
                if(res.data.code == 200){
                    this.agentList = res.data.data;
                }else {
                    this.$message.error(res.data.message)
                }
            })
        },
        
        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getAgentListHandle();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val;
            this.getAgentListHandle();
        }
    },
    created () {
        this.getAgentListHandle();
    }  
}
</script>

<style lang="less" scoped>

</style>

